import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoresComponent} from './stores.component';
import {StoreEditComponent} from './store-edit/store-edit.component';
import {StoreCreateComponent} from './store-create/store-create.component';
import {StoreFormComponent} from './store-form/store-form.component';
import {StoreIndexComponent} from './store-index/store-index.component';
import {StoresRoutesModule} from './store-routes/stores-routes.module';
import {CardModule} from '../../resources/components/card/card.module';
import {TableStoreModule} from '../../resources/tables/table-store/table-store.module';
import {StoreViewComponent} from './store-view/store-view.component';
import {TableUserModule} from '../../resources/tables/table-user/table-user.module';
import {TableProjectModule} from '../../resources/tables/table-project/table-project.module';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import {TableProductModule} from '../../resources/tables/table-product/table-product.module';
import {TableStoreVersionModule} from '../../resources/tables/table-store-version/table-store-version.module';
import {TableActionModule} from '../../resources/tables/table-action/table-action.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableStoreCollectionModule} from '../../resources/tables/table-store-collection/table-store-collection.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';
import {StoreViewProjectsComponent} from './store-view/store-view-projects/store-view-projects.component';
import {StoreViewPurchasesComponent} from './store-view/store-view-purchases/store-view-purchases.component';
import {StoreViewProductsComponent} from './store-view/store-view-products/store-view-products.component';
import {StoreViewCollectionsComponent} from './store-view/store-view-collections/store-view-collections.component';
import {StoreViewVersionsComponent} from './store-view/store-view-versions/store-view-versions.component';
import {StoreViewActionsComponent} from './store-view/store-view-actions/store-view-actions.component';
import {StoreViewUsersComponent} from './store-view/store-view-users/store-view-users.component';
import {StoreViewInfoComponent} from './store-view/store-view-info/store-view-info.component';
import {BadgeExistModule} from '../../resources/components/badge-exist/badge-exist.module';
import {EntityLinkModule} from "../../resources/components/entity-link/entity-link.module";
import {RouterOuterDirectiveModule} from "../../resources/directives/router-outer-directive/router-outer-directive.module";
import {SharedModule} from "../../modules/shared.module";
import {BtnDeleteModule} from "../../resources/components/btn-delete/btn-delete.module";
import { StoreViewSnapshotsComponent } from './store-view/store-view-snapshots/store-view-snapshots.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import {PortalModule} from "@angular/cdk/portal";
import {PreloaderModule} from "../../resources/components/preloader/preloader.module";
import {TabsRouteModule} from "../../resources/components/tabs-route/tabs-route.module";
import {StoreViewCustomDataComponent} from './store-view/store-view-custom-data/store-view-custom-data.component';
import {TableCustomDataModule} from '../../resources/tables/table-custom-data/table-custom-data.module';


@NgModule({
  declarations: [
    StoresComponent,
    StoreEditComponent,
    StoreCreateComponent,
    StoreFormComponent,
    StoreIndexComponent,
    StoreViewComponent,
    StoreViewProjectsComponent,
    StoreViewPurchasesComponent,
    StoreViewProductsComponent,
    StoreViewCollectionsComponent,
    StoreViewVersionsComponent,
    StoreViewActionsComponent,
    StoreViewUsersComponent,
    StoreViewInfoComponent,
    StoreViewSnapshotsComponent,
    StoreViewCustomDataComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    StoresRoutesModule,
    TableStoreModule,
    TableUserModule,
    TableProjectModule,
    TablePurchaseModule,
    TableProductModule,
    TableStoreVersionModule,
    TableActionModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    TableStoreCollectionModule,
    FormGroupSelectModule,
    BadgeExistModule,
    EntityLinkModule,
    RouterOuterDirectiveModule,
    SharedModule,
    BtnDeleteModule,
    NgxJsonViewerModule,
    PortalModule,
    PreloaderModule,
    TabsRouteModule,
    TableCustomDataModule
  ],
})
export class StoresModule {
}
